import { useCallback, useRef } from 'react';
export const useTouchInteraction = ({ onSwipeLeft, onSwipeRight, onSwipeDown, onTap, }) => {
    const touchStartTime = useRef(0);
    const touchStartX = useRef(0);
    const touchStartY = useRef(0);
    const multipleTouches = useRef(false);
    const wasTap = useRef(false);
    const SWIPE_TOUCH_X_MIN = 100;
    const SWIPE_TOUCH_Y_MIN = 50;
    const TOUCH_DURATION_MAX = 500;
    const handleTouchStart = useCallback((e) => {
        const touch = e.changedTouches[0];
        touchStartTime.current = Date.now();
        touchStartX.current = touch.pageX;
        touchStartY.current = touch.pageY;
        if (e.touches.length > 1) {
            multipleTouches.current = true;
        }
    }, [touchStartTime, touchStartX, touchStartY, multipleTouches]);
    const handleTouchEnd = useCallback((e) => {
        const touch = e.changedTouches[0];
        // abort swipe if multiple touches occurred
        if (multipleTouches.current) {
            if (e.touches.length === 0) {
                multipleTouches.current = false;
            }
            return;
        }
        const duration = Date.now() - touchStartTime.current;
        if (duration > TOUCH_DURATION_MAX) {
            return;
        }
        const distanceX = touch.pageX - touchStartX.current;
        const distanceY = touch.pageY - touchStartY.current;
        // assume horizontal swipe if distance traveled horizontally is greater than vertically
        if (Math.abs(distanceX) > Math.abs(distanceY)) {
            if (distanceX <= -SWIPE_TOUCH_X_MIN) {
                onSwipeLeft === null || onSwipeLeft === void 0 ? void 0 : onSwipeLeft();
                return;
            }
            else if (distanceX >= SWIPE_TOUCH_X_MIN) {
                onSwipeRight === null || onSwipeRight === void 0 ? void 0 : onSwipeRight();
                return;
            }
        }
        else {
            if (distanceY >= SWIPE_TOUCH_Y_MIN) {
                onSwipeDown === null || onSwipeDown === void 0 ? void 0 : onSwipeDown();
                return;
            }
        }
        // If not a swipe, then it was a tap.
        wasTap.current = true;
    }, [
        touchStartTime,
        touchStartX,
        touchStartY,
        multipleTouches,
        onSwipeLeft,
        onSwipeRight,
        onSwipeDown,
    ]);
    const handleClick = useCallback(() => {
        // Only use handler if click was triggered from a touch event
        if (wasTap.current) {
            onTap === null || onTap === void 0 ? void 0 : onTap();
            wasTap.current = false;
        }
    }, [onTap, wasTap]);
    return {
        handleTouchStart,
        handleTouchEnd,
        handleClick,
    };
};
//# sourceMappingURL=useTouchInteraction.preenvesnextjs.map
